<button type="button" class="locked-jaine-launcher" aria-label="Request an upgrade to access jAIne"
        (click)="openDialog()">
  <img src="images/jaine-bot.png" alt="jAIne">
</button>
